import React, { useRef } from "react";
import LandingPage from "../components/LandingPage";
import Footer from "../components/Footer";
import CardContainer from "../components/CardContainer";

const scrollToRef = ref => window.scrollTo(0, ref.current.offsetTop);

const Cities = props => {
  const storiesContainerRef = useRef(null);
  const handleBottomExpandClick = () => scrollToRef(storiesContainerRef);
  console.log("cities page loading");
  return (
    <>
      <LandingPage
        text="the cities edition"
        title="the b-side "
        handleBottomExpandClick={handleBottomExpandClick}
      ></LandingPage>
      <CardContainer refs={storiesContainerRef}></CardContainer>
      <Footer
        address="420 Maynard Street, Ann Arbor, MI 48105"
        phone="(734) 418 - 4115"
        copyright="Copyright © 1998-2020, all rights reserved. Edited and managed by the students at the University of Michigan since 1980."
        title="The Michigan Daily"
      ></Footer>
    </>
  );
};

export default Cities;
